import { useQuery } from '@tanstack/react-query'
import { ECurrency } from '../types/enums'
import { trpc } from '../utils'

const fetchTonWalletBalance = async (walletAddress: string) => {
  const response = await fetch(
    `https://toncenter.com/api/v2/getAddressBalance?address=${walletAddress}`,
  )
  const data = (await response.json()) as { ok: boolean; result: string }

  if (!data.ok) {
    throw new Error('Failed to fetch wallet balance')
  }

  return {
    ok: true,
    result: Number.parseFloat(data.result) / 1e9,
  }
}

export const useWalletBalance = (
  currency: ECurrency,
  walletAddress?: string,
) => {
  const tonQuery = useQuery({
    queryKey: ['walletBalance', walletAddress],
    queryFn: () => {
      if (!walletAddress) throw new Error('Missing wallet address')
      return fetchTonWalletBalance(walletAddress)
    },
    enabled: currency === ECurrency.TON && !!walletAddress,
    staleTime: 60_000,
    retry: 2,
  })

  const coinQuery = trpc.user.getBalance.useQuery(undefined, {
    enabled: currency === ECurrency.COIN,
  })

  if (currency === ECurrency.TON) {
    return tonQuery
  }
  if (currency === ECurrency.COIN) {
    return coinQuery
  }
  return null
}
